import { useState } from 'react';
import { TextField, Select } from '@shopify/polaris';
import { ResourceForm } from '../../../shared/components/ResourceForm';
import { FallbackRateInput } from './api';

const CURRENCY_OPTIONS = [
  { label: 'GBP', value: 'GBP' },
  { label: 'EUR', value: 'EUR' },
  { label: 'USD', value: 'USD' },
];

export interface FallbackRateFormProps {
  initial?: Partial<FallbackRateInput>;
  onSubmit: (input: FallbackRateInput) => void;
  onCancel: () => void;
  submitting?: boolean;
}

export function FallbackRateForm({
  initial,
  onSubmit,
  onCancel,
  submitting,
}: FallbackRateFormProps): JSX.Element {
  const [shopDomain, setShopDomain] = useState(initial?.shopDomain ?? '');
  const [postcodePattern, setPostcodePattern] = useState(initial?.postcodePattern ?? '');
  const [minWeightG, setMinWeightG] = useState(String(initial?.minWeightG ?? '0'));
  const [maxWeightG, setMaxWeightG] = useState(String(initial?.maxWeightG ?? '5000'));
  const [priceMinorUnits, setPriceMinorUnits] = useState(String(initial?.priceMinorUnits ?? '500'));
  const [currency, setCurrency] = useState(initial?.currency ?? 'GBP');
  const [serviceName, setServiceName] = useState(initial?.serviceName ?? 'Fallback service');

  function handleSubmit(): void {
    onSubmit({
      shopDomain,
      postcodePattern,
      minWeightG: Number(minWeightG),
      maxWeightG: Number(maxWeightG),
      priceMinorUnits: Number(priceMinorUnits),
      currency,
      serviceName,
    });
  }

  return (
    <ResourceForm onSubmit={handleSubmit} onCancel={onCancel} submitting={submitting}>
      <TextField
        label="Shop domain"
        value={shopDomain}
        onChange={setShopDomain}
        autoComplete="off"
        helpText="e.g. fjord.myshopify.com"
      />
      <TextField
        label="Postcode pattern"
        value={postcodePattern}
        onChange={setPostcodePattern}
        autoComplete="off"
        helpText="Regex, e.g. ^SW1.*"
      />
      <TextField
        label="Min weight (g)"
        type="number"
        value={minWeightG}
        onChange={setMinWeightG}
        autoComplete="off"
      />
      <TextField
        label="Max weight (g)"
        type="number"
        value={maxWeightG}
        onChange={setMaxWeightG}
        autoComplete="off"
      />
      <TextField
        label="Price (minor units, e.g. pence)"
        type="number"
        value={priceMinorUnits}
        onChange={setPriceMinorUnits}
        autoComplete="off"
      />
      <Select
        label="Currency"
        options={CURRENCY_OPTIONS}
        value={currency}
        onChange={setCurrency}
      />
      <TextField
        label="Service name"
        value={serviceName}
        onChange={setServiceName}
        autoComplete="off"
      />
    </ResourceForm>
  );
}
